import React from "react";
import { Controller } from "react-hook-form";

import Input from "../../../../../../../components/inputs/Input";
import Dropdown from "../../../../../../../components/inputs/Dropdown";

const FormFields = ({ control, errors }) => {
  return (
    <>
      <Controller
        name="name"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            classNameContainer="w-full mb-7"
            classNameInput="w-full"
            placeholder="Nombre"
            error={errors.name?.message}
            required
          />
        )}
      />
      <Controller
        name="idSystem"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            classNameContainer="w-full mb-7"
            classNameInput="w-full"
            placeholder="ID del sistema"
            error={errors.idSystem?.message}
            required
          />
        )}
      />
      <Controller
        name="isActive"
        control={control}
        render={({ field }) => (
          <Dropdown
            {...field}
            placeholder="Estado"
            error={errors.isActive?.message}
            required
            options={[
              { name: "Activo", value: true },
              { name: "Inactivo", value: false },
            ]}
            label1="name"
          />
        )}
      />
      <Controller
        name="dobleAuth"
        control={control}
        render={({ field }) => (
          <Dropdown
            {...field}
            placeholder="Doble factor de autenticación"
            error={errors.dobleAuth?.message}
            required
            options={[
              { name: "Sí", value: true },
              { name: "No", value: false },
            ]}
            label1="name"
          />
        )}
      />
    </>
  );
};
export default FormFields;
